import { render, staticRenderFns } from "./UtilityListPubCurrentLayout.vue?vue&type=template&id=4682548c&scoped=true&"
import script from "./UtilityListPubCurrentLayout.vue?vue&type=script&lang=js&"
export * from "./UtilityListPubCurrentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4682548c",
  null
  
)

export default component.exports